module.exports = __webpack_public_path__ + "static/media/backgroundoriginal.a2ae4e7e.jpeg";